// src/redux/reducers/likeReducer.js

const initialState = {
  sent: [],      // Likes envoyés par l'utilisateur
  received: [],  // Likes reçus
  sentDonneurOrdre: [],
  receivedDonneurOrdre: [],
};

const likeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LIKES_SENT":
      return { ...state, sent: action.payload };
    case "SET_LIKES_RECEIVED":
      return { ...state, received: action.payload };
    case "ADD_LIKE_SENT":
      return { ...state, sent: [...state.sent, action.payload] };
    case "ADD_LIKE_RECEIVED":
      return { ...state, received: [...state.received, action.payload] };
    case "SET_LIKES_SENT_DONNEUR_ORDRE":
      return { ...state, sentDonneurOrdre: action.payload };
    case "SET_LIKES_RECEIVED_DONNEUR_ORDRE":
      return { ...state, receivedDonneurOrdre: action.payload };
    case "ADD_LIKE_SENT_DONNEUR_ORDRE":
      return { ...state, sentDonneurOrdre: [...state.sentDonneurOrdre, action.payload] };
    case "ADD_LIKE_RECEIVED_DONNEUR_ORDRE":
      return { ...state, receivedDonneurOrdre: [...state.receivedDonneurOrdre, action.payload] };
    default:
      return state;
  }
};
export default likeReducer;